import Checkbox from 'components/atoms/Checkbox';
import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import css from './SelectAll.css';

const SelectAll = ({ allItems, onChange }) => {
    const disabledCount = allItems.filter(item => item.disabled).length;
    const selectedCount = allItems.filter(item => item.selected).length;
    const totalCount = allItems.length;
    const isSelectAll = totalCount - disabledCount === selectedCount;

    const handleChange = () => onChange(!isSelectAll);

    return (
        <div className={css.container} onClick={handleChange}>
            <Checkbox className={css.checkbox} checked={isSelectAll} size="small" onChange={handleChange} />
            <div className={css.name}>
                <Translate id="STATIC.PAGES.TEAM_MEMBERS.MANAGE_PERMISSIONS_PAGE.SELECT_ALL" />
            </div>
        </div>
    );
};

SelectAll.propTypes = {
    allItems: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            id: PropTypes.number.isRequired,
            selected: PropTypes.bool.isRequired,
            disabled: PropTypes.bool,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default SelectAll;
